














































































































































/*
  getParam 获取考官教师聘用页面参数
  getExaminerEmploy 获取考官教师聘用分页列表
*/
import { Vue, Component } from "vue-property-decorator";
//引入接口调用函数
import {
  getParam,
  getExaminerEmploy,
  deleteInfo
} from "../../../api/examinerTeacherEmploy";
import importAndExportMixin from "../../../mixins/importAndExport";

@Component({
  name: "examinerTeacherEmploy",
  mixins: [importAndExportMixin],
  components: {
    UploadProgress: () => import("@/components/UploadProgress/index.vue"),
  },
})
export default class extends Vue {
  private projectId: string = ""; //项目id
  private subjectId: string = ""; //科目id
  private employStatus: string = ""; //聘用状态
  private examinationPlace: string = ""; //考点
  private teacherName: string = ""; //教师
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseArray: object[] = []; //勾选的数据集合
  //页面参数
  private projects: object[] = []; //项目数组
  private subjects: object[] = []; //科目数组
  private tableHeight: number = 0;
  public $refs!: {
    table: HTMLFormElement;
  };
  private uploadData = {progressId: -1, projectId: this.projectId}; // 文件上传入参

  created() {
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  //上传地址
  get uploadUrl() {
    return window.config.baseUrl4Shool + "/examinerteacher/examinerEmploy/import";
  }

  //获取页面参数
  private async getParams() {
    try {
      let res = await getParam();
      this.projects = res.data.projects;
      this.subjects = res.data.subjects;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //列表接口和导出接口的传参
  private getRequestParams() {
    return {
      current: this.pageNo, //当前页
      size: this.pageSize, //记录数
      employState: this.employStatus, //聘用状态 0:已聘用 1:作废聘用
      placeName: this.examinationPlace, //考点名称
      projectId: this.projectId, //项目id
      subjectId: this.subjectId, //科目id
      teacherName: this.teacherName //教师名称
    };
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    try {
      let res = await getExaminerEmploy(this.getRequestParams());
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    //保存勾选的教师数据
    this.chooseArray = v.map((item: any) => {
      return {
        projectId:  item['projectId'], // 项目id
        subjectId: item[`subjectId`], // 科目id
        teacherId:  item[`teacherId`] // 教师id
      }
    });
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  //表头特殊单元格样式处理
  private cellStyleHandle({ row, column }: any) {
    let labelArr = ["岗位", "分配考点", "分配分组", "聘用状态", "校区", "考场编号", "考场名称"];
    if (labelArr.includes(column.label)) {
      return "background-color: #f4eeff;";
    }
  }

  //删除处理
  private deleteHandle() {
    if (this.chooseArray.length <= 0) {
      this.$message.warning("请勾选教师！");
      return false;
    }
    //询问是否删除
    this.$confirm("确定删除?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      try {
        await deleteInfo(this.chooseArray);
        this.$message.success("删除成功");
        //操作成功，重新获取列表
        this.getData();
      } catch (error) {
        this.$message.error(error.mesg || error || "删除失败");
      }
    });
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
